module.exports = __webpack_public_path__ + "static/media/cws5_banner_extra1.7ce1b51f.jpg";